import { useState, useEffect } from 'react';
import Footer from './components/Footer/Footer';
import Navbar from './components/Navbar/Navbar';
import './index.css';
import LoadingScreen from './components/animation/LoadingScreen';
import ThemeButton from './components/Theme/ThemeButton';
import Home from './Pages/Home';
import { Routes, Route, Navigate } from 'react-router-dom';
import Error404 from './Pages/PageNotFound/Error404';

function App() {
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(!open);
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 700);
  }, []);

  return (
    <div className="bg-whitish dark:bg-greenish font-sans">
      {loading === true ? (
        <LoadingScreen />
      ) : (
        <>
          <Navbar open={open} setOpen={handleOpen} />
          <ThemeButton />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="404" element={<Error404 />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
